import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Tooltip } from 'wix-style-react'
import * as _ from 'lodash'

import Text from 'components/common/Text'
import SimplePagination from 'components/shared/SimplePagination'
import { api } from 'api/integrationAPI'
import { HELVETICA, BLUE } from 'components/styles'
import OptionsView from 'components/editor/popovers/shopifyVariantsPopover/OptionsView'
import { setCustomFieldArray } from 'controllers/logic'
import Card from 'components/shared/Card'
import { toFirebaseKey } from 'utils/utils'

const Container = styled.div`
  width: 100%;
  height: 8em;
  margin-top: 1em;
  display: flex;
  flex-direction: column;
`
const ItemsContainer = styled.div`
  width: 26em;
  height: 8em;
  margin-top: 1em;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`
const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
  border-radius: 0.5em;
  vertical-align: middle;
`
const ProductPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 0.2em;
  margin-right: 0.2em;
  width: 6em;
`
const OptionsButton = styled.div`
  margin-top: 0.5em;
  width: 5em;
  height: 1.5em;
  border-radius: 0.8em;
  border: solid 0.5px ${BLUE};
  color: ${BLUE};
  display: flex;
  align-items: center;
  justify-content: center;
  ${HELVETICA}
  font-size: 12px;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: #fff;
    background-color: ${BLUE}
  }
`
const OptionsViewContainer = styled.div`
  width: 32em;
  min-height: 12em;
`

class TaggedProductsList extends Component {

  constructor (props) {
    super(props)
    this.state = {
      tooltipProductId: -1
    }
  }

  editOptions = (productInfo) => {
    return (e) => {
      // console.log('editOptions', productInfo)
      this.setState({
        tooltipProductId: productInfo.productId
      })
    }
  }

  updateProductColor = (p, i) => {
    return (titleRaw, value) => {
      const title = toFirebaseKey(titleRaw)
      const { postIndex, dispatch, appId } = this.props
      // console.log('updateProductColor', i, title, value)
      const product = _.clone(p)
      if (value === null) {
        _.unset(product, ['info', 'colorOptions', title])
      } else {
        _.set(product, ['info', 'colorOptions', title], value)
      }
      dispatch(setCustomFieldArray(appId, ['showcases', postIndex, 'products', i], product))
    }
  }

  renderColorOptions = (p, productInfo, i) => {
    return (
      <OptionsViewContainer id='optionsViewContainer'>
        <OptionsView
          productInfo={productInfo}
          updateProductColor={this.updateProductColor(p, i)}
        />
      </OptionsViewContainer>
    )
  }

  onClickOutside = (e) => {
    // console.log('onClickOutside', e)
    let needClose = true
    for (const elt of e.path) {
      if (elt.id === 'optionsViewContainer' || elt.id === 'colorPicker') needClose = false
    }
    if (needClose) this.setState({ tooltipProductId: -1 })
  }

  renderButtonIfNeeded = (p, productInfo, i) => {
    const { tooltipProductId } = this.state
    const options = _.get(productInfo, ['details', 'options'], [])
    if (options.length > 0) {
      return (
        <Tooltip
          id={'colorTooltip'}
          content={this.renderColorOptions(p, productInfo, i)}
          hideTrigger='custom'
          onClickOutside={this.onClickOutside}
          onShow={null}
          placement='top'
          shouldCloseOnClickOutside={false}
          showTrigger='click'
          active={tooltipProductId === productInfo.productId}
        >
          <OptionsButton onClick={this.editOptions(productInfo)}>
            Variants
          </OptionsButton>
        </Tooltip>
      )
    }
  }

  onImageClick = (i) => {
    return (e) => {
      this.props.onImageClick(i)
    }
  }

  renderProduct = (p, i) => {
    if (p.info) {
      const { productsDict } = this.props
      const productInfo = api.getProductInfo(p.info, productsDict)
      return (
        <ProductPreviewContainer key={i}>
          <Card
            width='6em'
            height='6em'
            pointer
            onClick={this.onImageClick(i)}
          >
            <Image src={_.get(productInfo, ['details', 'images', 0])} />
          </Card>
          {this.renderButtonIfNeeded(p, productInfo, i)}
        </ProductPreviewContainer>
      )
    }
  }

  render () {
    const { products } = this.props
    if (products.length > 0) {
      return (
        <Container>
          <Text>Tagged Products</Text>
          <SimplePagination
            ItemsContainer={ItemsContainer}
            items={_.map(products, this.renderProduct)}
            itemsVisible={4}
          />
        </Container>
      )
    } else {
      return null
    }
  }
}

TaggedProductsList.defaultProps = {
  products: [],
  onImageClick: () => null
}

TaggedProductsList.propTypes = {
  appId: PropTypes.string.isRequired,
  postIndex: PropTypes.number.isRequired,
  products: PropTypes.array,
  productsDict: PropTypes.object.isRequired,
  onImageClick: PropTypes.func
}

export default connect()(TaggedProductsList)



// WEBPACK FOOTER //
// ./src/components/editor/insta/instaTagPosts/tagProducts/TaggedProductsList.js